import React, {Component} from "react";
import SportIcon from "../SportIcon";
import EventHelper from "../../helpers/EventHelper";
import * as lodash from "lodash";
import Favorite from "../Favorite";
import {Link} from "react-router-dom";

class Sport extends Component {
	state = {
		elemOpened : false,
	};

	handleClick(event) {
		event.preventDefault();
		this.setState({
			elemOpened : !this.state.elemOpened
		});
	}

	render() {
		const {sport, events} = this.props;

		const sortedEvents = lodash.sortBy(events, e => e.time);

		const eventsData = sortedEvents.map((event) => {
			const teams = EventHelper.parseTeams(event.team1, event.team2);

			return (
				<li>
					<Favorite eventId={event.id} type={2}/>
					<Link to={`/live/${event.id}`}>{teams}</Link>
				</li>
			)
		});

		return (
			<div>
				<li onClick={this.handleClick.bind(this)} className={this.state.elemOpened ? 'opened' : ''}>
					<span className="top-event-list__icon">
						<span className="sport-icon small green">
							<SportIcon sportId={sport.id}/>
						</span>
					</span>
					<span>{sport.name}</span>
					<a className={`top-event-list__plus ${this.state.elemOpened ? 'minus' : 'plus'}`}>
						<i className={`fas ${this.state.elemOpened ? 'fa-minus' : 'fa-plus'}`}></i>
					</a>
				</li>

				<div className={`top-event-list__sub ${this.state.elemOpened && 'show'}`}>
					<ul className="top-event-list__sub-leagues leagues">
						{eventsData}
					</ul>
				</div>
			</div>
		);
	}
}

export default Sport;


// WEBPACK FOOTER //
// ./src/app/components/LiveWidget/Sport.js